import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import { ICloseReturnType, PlaceholderChildComponent } from '@ispm/layout/classes/placeholder-child-component.abstract';
import { DynamicFormModalPayload } from '@ispm/dynamic-form/classes/dynamic-form-modal-payload.class';
import { modalResponse } from '@ispm/layout/constants/modal-responses.enum';
import { DynamicFormModalResponse } from '@ispm/dynamic-form/classes/dynamic-form-modal-response.class';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'gen-dynamic-form-modal',
  templateUrl: './dynamic-form-modal.component.html',
  styleUrls: ['./dynamic-form-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DynamicFormModalComponent<Payload extends DynamicFormModalPayload = DynamicFormModalPayload>
              extends PlaceholderChildComponent<Payload, DynamicFormModalResponse> implements OnInit {
  public valid: boolean;
  public submitted: boolean;
  public formData: any;
  public globalConfiguration : any;
  public updatedFields: string[] = [];

  constructor(private _changeDetector: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.formData = this.payload.formData || { };
    this.formData = cloneDeep(this.formData);
    this.globalConfiguration = this.payload.globalConfigurations;
  }

  updateFormData(formData, isInit?:boolean) {
    if(isInit) {
      this.formData = formData;
    } else {
      this.formData = formData.form;
      this.updatedFields.push.apply(this.updatedFields, formData.updated);
    }

  }

  beforeClose(_modalResponse?: modalResponse):  DynamicFormModalResponse & ICloseReturnType {
    this.submitted =  _modalResponse !== modalResponse.decline;
    this._changeDetector.markForCheck();
    return new Promise((resolve) => {
      setTimeout(()=> {
        resolve( Object.assign({isValid: this.valid || _modalResponse === modalResponse.decline},
          new DynamicFormModalResponse(this.formData, this.valid, this.updatedFields, _modalResponse)));
      },0);
    });
  }




}



